import Layout from '../components/layout/Layout';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { AlertTriangle } from 'lucide-react';

const WiderrufsrechtPage = () => {
  return (
    <Layout>
      <div className="min-h-screen bg-secondary py-12" data-testid="widerrufsrecht-page">
        <div className="max-w-4xl mx-auto px-4">
          <div className="flex items-start gap-3 bg-amber-50 border border-amber-300 text-amber-900 rounded-lg p-4 mb-6">
            <AlertTriangle className="h-5 w-5 mt-0.5 flex-shrink-0" />
            <p className="text-sm">
              <strong>Platzhalter — rechtlich noch zu prüfen.</strong> Dies ist ein Entwurf auf
              Basis der gesetzlichen EU-Musterbelehrung. Die eckigen Platzhalter (Unternehmensdaten)
              müssen durch die Angaben aus dem finalen Impressum ersetzt und von einem
              Rechtsanwalt geprüft werden, bevor diese Seite verbindlich genutzt wird.
            </p>
          </div>

          <Card>
            <CardHeader>
              <CardTitle className="font-serif text-3xl">Widerrufsrecht</CardTitle>
            </CardHeader>
            <CardContent className="prose prose-sm max-w-none">
              <h2>Widerrufsbelehrung</h2>
              <p>
                Verbrauchern steht ein gesetzliches Widerrufsrecht gemäß den folgenden Bestimmungen
                zu, wenn ein entgeltlicher Vertrag mit [Firmenname, siehe Impressum] über die
                Buchung eines Hochzeitsplatzes über WEDVAYA geschlossen wird.
              </p>

              <h3>Widerrufsrecht</h3>
              <p>
                Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen diesen Vertrag
                zu widerrufen. Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag des
                Vertragsabschlusses.
              </p>
              <p>
                Um Ihr Widerrufsrecht auszuüben, müssen Sie uns ([Firmenname], [Adresse],
                E-Mail: kontakt@wedvaya.com) mittels einer eindeutigen Erklärung (z. B. ein mit der
                Post versandter Brief oder E-Mail) über Ihren Entschluss, diesen Vertrag zu
                widerrufen, informieren. Sie können dafür das unten stehende Muster-Widerrufsformular
                verwenden, das jedoch nicht vorgeschrieben ist.
              </p>
              <p>
                Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung über die
                Ausübung des Widerrufsrechts vor Ablauf der Widerrufsfrist absenden.
              </p>

              <h3>Folgen des Widerrufs</h3>
              <p>
                Wenn Sie diesen Vertrag widerrufen, erstatten wir Ihnen alle Zahlungen, die wir von
                Ihnen erhalten haben, unverzüglich und spätestens binnen vierzehn Tagen ab dem Tag,
                an dem die Mitteilung über Ihren Widerruf bei uns eingegangen ist. Für diese
                Rückzahlung verwenden wir dasselbe Zahlungsmittel, das Sie bei der ursprünglichen
                Transaktion eingesetzt haben, es sei denn, mit Ihnen wurde ausdrücklich etwas
                anderes vereinbart.
              </p>

              <h3>Vorzeitiges Erlöschen des Widerrufsrechts</h3>
              <p>
                Das Widerrufsrecht erlischt vorzeitig, wenn der Vertrag eine Dienstleistung im
                Zusammenhang mit Freizeitbetätigungen betrifft und der Vertrag für die Erbringung
                einen spezifischen Termin oder Zeitraum vorsieht (z. B. das konkrete Hochzeitsdatum).
                In diesem Fall kann das Widerrufsrecht bereits vor Ablauf der 14-Tage-Frist
                erlöschen, sobald das Event stattgefunden hat. [Final mit Rechtsberatung abstimmen,
                insbesondere Abgrenzung zu § 312g Abs. 2 Nr. 9 BGB.]
              </p>

              <h2>Muster-Widerrufsformular</h2>
              <p>
                (Wenn Sie den Vertrag widerrufen wollen, füllen Sie bitte dieses Formular aus und
                senden Sie es zurück.)
              </p>
              <p>
                An [Firmenname, Anschrift, E-Mail — siehe Impressum]:<br /><br />
                Hiermit widerrufe(n) ich/wir den von mir/uns abgeschlossenen Vertrag über die
                Buchung des folgenden Hochzeitsplatzes:<br />
                — Bestellt am: _______________<br />
                — Name des/der Verbraucher(s): _______________<br />
                — Anschrift des/der Verbraucher(s): _______________<br />
                — Datum: _______________
              </p>

              <p className="text-sm text-muted-foreground mt-8">
                Entwurf — nicht veröffentlicht
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </Layout>
  );
};

export default WiderrufsrechtPage;
